module.exports = __webpack_public_path__ + "img/ematrica-logo.54ca8cf4.svg";